import { render, staticRenderFns } from "./Earth.vue?vue&type=template&id=5fa73d34&scoped=true&"
import script from "./Earth.vue?vue&type=script&lang=js&"
export * from "./Earth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa73d34",
  null
  
)

export default component.exports